// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex {
  display: flex;
}
.avatar {
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
}
.flex-col {
  flex-direction: column !important;
}
.purple {
  background-color: #7D44F3;
}
.text-purple {
  color: #7D44F3;
  text-align: right;
}
.text-primary {
  color: #1677ff;
}
.profile-drawer {
  font-size: 32px;
}
.profile-drawer > div > .ant-drawer-header {
  background-color: #FBF6FF;
}
.profile-form {
  font-size: 16px;
}
.profile-pic {
  display: flex;
  justify-content: center;
}
.profile-group-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.profile-edit-icon {
  font-size: 2em;
}
.profile-uploader {
  display: flex !important;
  justify-content: center;
  width: max-content;
  height: max-content;
}
.profile-uploader > .ant-upload {
  width: max-content !important;
  height: max-content !important;
}
.profile-form-group {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.profile-label {
  font-size: 1em !important;
  color: #5C5C5C !important;
}
.profile-text {
  font-size: 1em !important;
  font-weight: 600 !important;
}
.profile-text[type="button"] {
  text-align: right;
}
.profile-text[type="button"]:hover {
  opacity: 0.8;
}
.password-form-wrap {
  display: flex;
  flex-direction: column;
}
.profile-input {
  cursor: default !important;
  font-size: 18px !important;
  color: #000 !important;
  font-weight: 500 !important;
  text-align: center;
}
.profile-input#name {
  text-align: center !important;
}
.profile-input#name:hover,
.profile-input#password:hover,
.profile-input#confirmPassword:hover {
  cursor: text !important;
}
.profile-button-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.profile-button {
  flex: 1 0;
}
.profile-button + .cancel:hover {
  opacity: 80%;
  border-color: #7D44F3 !important;
  color: #7D44F3 !important;
}
.profile-button + .purple:hover {
  opacity: 80%;
  background-color: #7D44F3 !important;
  color: #fff !important;
}
.edit-btn-wrapper {
  position: absolute;
  bottom: 32px;
  right: 32px;
}
.edit-btn-wrapper > button {
  color: #1677ff;
  border-color: #1677ff;
}
@media (min-width: 576px) {
  .profile-uploader > .ant-upload > span {
    width: 64px !important;
    height: 64px !important;
  }
}
/* Medium screens (768px and up) */
@media (min-width: 768px) {
  .profile-uploader > .ant-upload > span {
    width: 80px !important;
    height: 80px !important;
  }
}
/* Large screens (992px and up) */
@media (min-width: 992px) {
  .profile-uploader > .ant-upload > span {
    width: 100px !important;
    height: 100px !important;
  }
}
/* Extra large screens (1200px and up) */
@media (min-width: 1200px) {
  .profile-uploader > .ant-upload > span {
    width: 150px !important;
    height: 150px !important;
  }
}
/* Extra extra large screens (1600px and up) */
@media (min-width: 1600px) {
  .profile-uploader > .ant-upload > span {
    width: 200px !important;
    height: 200px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/style/Profile.less"],"names":[],"mappings":"AAIA;EACI,aAAA;AAHJ;AAKA;EACI,+CAAA;AAHJ;AAMA;EACI,iCAAA;AAJJ;AAOA;EACI,yBAAA;AALJ;AAQA;EACI,cAAA;EACA,iBAAA;AANJ;AASA;EACI,cAAA;AAPJ;AAYA;EACI,eAAA;AAVJ;AAaA;EACI,yBAAA;AAXJ;AAcA;EACI,eAAA;AAZJ;AAeA;EACI,aAAA;EACA,uBAAA;AAbJ;AAgBA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAdJ;AAiBA;EACI,cAAA;AAfJ;AAkBA;EACI,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAhBJ;AAmBA;EACI,6BAAA;EACA,8BAAA;AAjBJ;AAoBA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAlBJ;AAqBA;EACI,yBAAA;EACA,yBAAA;AAnBJ;AAsBA;EACI,yBAAA;EACA,2BAAA;AApBJ;AAuBA;EACI,iBAAA;AArBJ;AAwBA;EACI,YAAA;AAtBJ;AAyBA;EACI,aAAA;EACA,sBAAA;AAvBJ;AA0BA;EACI,0BAAA;EACA,0BAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AAxBJ;AA2BA;EACI,6BAAA;AAzBJ;AA4BA;;;EAGI,uBAAA;AA1BJ;AA6BA;EACI,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AA3BJ;AA8BA;EACI,SAAA;AA5BJ;AA+BA;EACI,YAAA;EACA,gCAAA;EACA,yBAAA;AA7BJ;AAgCA;EACI,YAAA;EACA,oCAAA;EACA,sBAAA;AA9BJ;AAiCA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AA/BJ;AAiCA;EACI,cAAA;EACA,qBAAA;AA/BJ;AAkCA;EACI;IACI,sBAAA;IACA,uBAAA;EAhCN;AACF;AACA,kCAAkC;AAmClC;EACI;IACI,sBAAA;IACA,uBAAA;EAjCN;AACF;AACA,iCAAiC;AAoCjC;EACI;IACI,uBAAA;IACA,wBAAA;EAlCN;AACF;AACA,wCAAwC;AAsCxC;EACI;IACI,uBAAA;IACA,wBAAA;EApCN;AACF;AACA,8CAA8C;AAuC9C;EACI;IACI,uBAAA;IACA,wBAAA;EArCN;AACF","sourcesContent":["@labelColor: #5C5C5C;\n@primaryColor: #7D44F3;\n\n//preclass\n.flex {\n    display: flex;\n}\n.avatar{\n    box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.15)\n}\n\n.flex-col {\n    flex-direction: column !important;\n}\n\n.purple {\n    background-color: @primaryColor;\n}\n\n.text-purple {\n    color: @primaryColor;\n    text-align: right;\n}\n\n.text-primary{\n    color: #1677ff;\n}\n\n//profile component class\n\n.profile-drawer {\n    font-size: 32px;\n}\n\n.profile-drawer>div>.ant-drawer-header {\n    background-color: #FBF6FF;\n}\n\n.profile-form {\n    font-size: 16px;\n}\n\n.profile-pic {\n    display: flex;\n    justify-content: center;\n}\n\n.profile-group-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n}\n\n.profile-edit-icon {\n    font-size: 2em;\n}\n\n.profile-uploader {\n    display: flex !important;\n    justify-content: center;\n    width: max-content;\n    height: max-content;\n}\n\n.profile-uploader>.ant-upload {\n    width: max-content !important;\n    height: max-content !important;\n}\n\n.profile-form-group {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n}\n\n.profile-label {\n    font-size: 1em !important;\n    color: @labelColor !important;\n}\n\n.profile-text {\n    font-size: 1em !important;\n    font-weight: 600 !important;\n}\n\n.profile-text[type=\"button\"] {\n    text-align: right;\n}\n\n.profile-text[type=\"button\"]:hover {\n    opacity: 0.8;\n}\n\n.password-form-wrap {\n    display: flex;\n    flex-direction: column;\n}\n\n.profile-input {\n    cursor: default !important;\n    font-size: 18px !important;\n    color: #000 !important;\n    font-weight: 500 !important;\n    text-align: center;\n}\n\n.profile-input#name {\n    text-align: center !important;\n}\n\n.profile-input#name:hover,\n.profile-input#password:hover,\n.profile-input#confirmPassword:hover {\n    cursor: text !important;\n}\n\n.profile-button-container {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 20px;\n    align-self: stretch;\n}\n\n.profile-button {\n    flex: 1 0 0;\n}\n\n.profile-button+.cancel:hover {\n    opacity: 80%;\n    border-color: @primaryColor !important;\n    color: @primaryColor !important;\n}\n\n.profile-button+.purple:hover {\n    opacity: 80%;\n    background-color: @primaryColor !important;\n    color: #fff !important;\n}\n\n.edit-btn-wrapper {\n    position: absolute;\n    bottom: 32px;\n    right: 32px;\n}\n.edit-btn-wrapper > button{\n    color: #1677ff;\n    border-color: #1677ff;\n}\n\n@media (min-width: 576px) {\n    .profile-uploader>.ant-upload>span {\n        width: 64px !important;\n        height: 64px !important;\n    }\n}\n\n/* Medium screens (768px and up) */\n@media (min-width: 768px) {\n    .profile-uploader>.ant-upload>span {\n        width: 80px !important;\n        height: 80px !important;\n    }\n}\n\n/* Large screens (992px and up) */\n@media (min-width: 992px) {\n    .profile-uploader>.ant-upload>span {\n        width: 100px !important;\n        height: 100px !important;\n    }\n\n}\n\n/* Extra large screens (1200px and up) */\n@media (min-width: 1200px) {\n    .profile-uploader>.ant-upload>span {\n        width: 150px !important;\n        height: 150px !important;\n    }\n}\n\n/* Extra extra large screens (1600px and up) */\n@media (min-width: 1600px) {\n    .profile-uploader>.ant-upload>span {\n        width: 200px !important;\n        height: 200px !important;\n    }\n}\n\n// .slide-bottom {\n//     -webkit-animation: slide-bottom 0.5s ease-in both;\n//     animation: slide-bottom 0.5s ease-in both;\n// }\n// @keyframes slide-bottom {\n//     0% {\n//         -webkit-transform: translateY(-10px);\n//         transform: translateY(-10px);\n//     }\n\n//     100% {\n//         -webkit-transform: translateY(0px);\n//         transform: translateY(0px);\n//     }\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
